import { render, staticRenderFns } from "./NotesComponent.vue?vue&type=template&id=f74ceaa8&scoped=true&"
import script from "./NotesComponent.vue?vue&type=script&lang=js&"
export * from "./NotesComponent.vue?vue&type=script&lang=js&"
import style0 from "./NotesComponent.vue?vue&type=style&index=0&id=f74ceaa8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f74ceaa8",
  null
  
)

export default component.exports